import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
//Operator
import CreateOperator from '../../views/Operator/CreateOperator'
import OperatorList from '../../views/Operator/OperatorList'
import EditOperator from '../../views/Operator/EditOperator'

const CustomerUsers = () => {
  return (
    <div>
      <Routes>
        <Route
          path="/customerUsers/creatOperator"
          element={<CreateOperator />}
        />

        <Route
          path="/customerUsers/editOperator/:userID/:userEmail"
          element={<EditOperator />}
        />

        <Route
          path="/customerUsers"
          element={<OperatorList />}
        />

        <Route path="/" element={<Navigate to="/customerUsers" replace />} />
      </Routes>
    </div>
  )
}
//<Container fluid>
export default CustomerUsers
